import { Component, Input, OnInit } from '@angular/core';
import {
  CopyrightAndTitleService,
  CopyrightTitleTaskDTO,
} from '@compumark/analyst-selection-tool-client';
import { Observable } from 'rxjs';
@Component({
  selector: 'app-copyright-title-task-details',
  standalone: false,
  templateUrl: './copyright-title-task-details.component.html',
  styleUrls: ['./copyright-title-task-details.component.scss'],
})
export class CopyrightTitleTaskDetailsComponent implements OnInit {
  @Input() taskId?: string;
  data$: Observable<CopyrightTitleTaskDTO> =
    new Observable<CopyrightTitleTaskDTO>();

  constructor(private copyrightAndTitleService: CopyrightAndTitleService) {}

  ngOnInit(): void {
    this.data$ = this.copyrightAndTitleService.getCRTTask(this.taskId!);
  }

  refresh(): boolean {
    return false;
  }
}
